import { useMutation } from 'react-query';

import { ErrorResponse } from 'api/types/errors';
import {
  confirmCheckoutSession,
  startCheckoutSession,
  updateCheckoutSession
} from 'api/services/organizations/memberships-checkout';
import {
  IncomingProductCheckoutSessionUpdateDto,
  OutgoingProductCheckoutSessionDto
} from 'api/dtos/products/checkout';

export function useStartCheckoutSession() {
  return useMutation<OutgoingProductCheckoutSessionDto, ErrorResponse, string>(
    startCheckoutSession
  );
}

export function useUpdateCheckoutSession() {
  return useMutation<
    OutgoingProductCheckoutSessionDto,
    ErrorResponse,
    {
      organizationId: string;
      paymentIntentId: string;
      data: IncomingProductCheckoutSessionUpdateDto;
    }
  >(updateCheckoutSession);
}

export function useConfirmCheckoutSession() {
  return useMutation<
    { redirectUrl?: string },
    ErrorResponse,
    {
      organizationId: string;
      paymentIntentId: string;
    }
  >(confirmCheckoutSession);
}
